import React, { useState, useEffect } from "react";
import moment from "moment";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";

// component
import { USER_KEY } from "../../../const";
import AnimationLoading from "../../../components/Animationloading";
import {
  successSwal,
  errorSwal,
  successDeleteSwal,
  successUpdateSwal,
} from "../../../helper/sweetalert";
import CustomButton from "../../../components/CustomButton";
import EmptyComponent from "../../../components/EmptyComponent";
import PaginationHelper from "../../../components/PaginationHelper";
import ConfirmDelete from "../../../components/ConfirmDelete";

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CREATE_UNIT,
  DELETE_UNIT,
  UPDATE_UNIT,
} from "../../../apollo/unit/Mutation";
import { GET_UNITS } from "../../../apollo/unit/Query";

// icon
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineBorderColor } from "react-icons/md";

// react bootrap
import { Form, Modal, Spinner, Table, InputGroup, Button } from "react-bootstrap";
import ComfirmModal from "../../../components/ComfirmModal";
import { ReactIcons } from "../../../icons";

function UnitList() {
  const history = useHistory();
  const [Unit, setUnit] = useState();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [unitTotal, setUnitTotal] = useState();
  const [searchUnit, setSearchUnit] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const { _limit, _skip, Pagination_helper } = PaginationHelper();
  const [showAddUnit, setShowAddUnit] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});

  // ======== Query And Mutation ==========

  const [LoadUnit, { data: GetUnitData, loading }] = useLazyQuery(GET_UNITS, {
    fetchPolicy: "cache-and-network",
  });
  const [createunit, { loading: loadingCreate }] = useMutation(CREATE_UNIT);
  const [deleteunit, { loading: loadingDelete }] = useMutation(DELETE_UNIT);
  const [updateunit, { loading: loadingUpdate }] = useMutation(UPDATE_UNIT);

  // ==========> useEffect <==========

  useEffect(() => {
    if (GetUnitData) {
      setUnit(GetUnitData?.units?.data);
      setUnitTotal(GetUnitData?.units?.total);
    }
  }, [GetUnitData]);

  useEffect(() => {
    onNextOrBackPage();
  }, [pageNumber]);

  useEffect(() => {
    onNextOrBackPage();
  }, [_skip]);

  useEffect(() => {
    _filter();
  }, [searchUnit]);

  // ==========> Fuction <==========

  const _filter = async () => {
    try {
      let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;

      let _where = {
        shop: shopId,
        isDeleted: false,
      };

      // TODO: check if search text is not empty
      // if (!_.isEmpty(searchCategory)) { _where = { ..._where, title: searchCategory, } }
      if (searchUnit !== "") {
        _where = {
          ..._where,
          name: searchUnit,
        };
      }

      // TODO: Get all product

      await LoadUnit({
        orderBy: "createdAt_DESC",
        variables: {
          limit: 800,
          where: _where,
        },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  // ==========> fuction pagination  <==========
  const onNextOrBackPage = async () => {
    try {
      const shopId = await JSON.parse(localStorage.getItem(USER_KEY))?.data
        ?.shop?.id;

      await LoadUnit({
        variables: {
          where: {
            isDeleted: false,
            shop: shopId,
          },
          skip: null,
          limit: null,
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  // ==========> Fuction Delete <==========

  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const handleShowDelete = (id, name) => {
    setDelete({ name, id });
    setShowDelete(true);
  };

  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteunit({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      _filter();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  // ======= Create Unit ==========

  const _createUnit = async (values) => {
    if (!values.name) {
      errorSwal("ກະລຸນາເພີ່ມຊື່ຫົວໜວ່ຍ...");
      return;
    }
    try {
      if (loadingCreate) return;
      await createunit({
        variables: {
          data: {
            ...values,
          },
        },
      });
      _filter();
      setShowAddUnit(false);
      successSwal("ເພີ່ມສຳເລັດ");
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      // console.log('error creating todo:', err)
    }
  };

  // <============== Update Unit =================>
  const _updateUnit = async () => {
    try {
      if (loadingUpdate) return;
      await updateunit({
        variables: {
          where: {
            id: editData?.id,
          },
          data: {
            name: editData?.name,
          },
        },
      });
      setIsEdit(false);
      setEditIndex();
      setEditData({});
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      _filter();
    } catch (err) {
      errorSwal("ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ");
      // console.log("error creating todo:", err);
    }
  };

  // ==========> Fuction Edit Unit <==========

  const onEditData = async (data, index) => {
    setIsEdit(true);
    setEditIndex(index);
    setEditData(data);
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  return (
    <React.Fragment>
      <div>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            padding: "20px",
            overflow: "auto",
          }}>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}>
            <div style={{ width: "30%" }}>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}>
                  <SearchIcon sx={{ color: "#6B7280" }} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="ຄົ້ນຫາ..."
                  aria-describedby="basic-addon2"
                  onChange={(e) => {
                    setSearchUnit(e.target.value);
                  }}
                  value={searchUnit}
                  style={{
                    borderLeft: "none",
                    // width: '40px',
                    // maxWidth: '420px'
                  }}
                />
              </InputGroup>
            </div>
            <CustomButton
              width="130px"
              title="ເພີ່ມ"
              icon={<ReactIcons.MdAdd />}
              borderRadius="8px"
              onClick={() => setShowAddUnit(true)}
            />
          </div>
          {loading && !GetUnitData ? (
            <AnimationLoading />
          ) : (
            <>
              {Unit?.length > 0 ? (
                <Table
                  responsive
                  style={{
                    marginTop: "20px",
                    borderCollapse: "collapse",
                    width: "100% ",
                  }}>
                  <thead
                    style={{
                      background: "#1F3A60",
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      <th>ລ/ດ</th>
                      <th>ຫົວໜ່ວຍ</th>
                      <th>ວັນທີເດືອນປີ</th>
                      <th style={{textAlign:'right'}}>ຈັດການ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Unit?.map((unit, index) => (
                      <tr key={index}>
                        <td style={{ paddingTop: "1rem" }}>{index + 1}</td>
                        <td style={{ paddingTop: "1rem" }}>
                          {isEdit == true && editIndex === index ? (
                            <Form.Control
                              type="text"
                              name="name"
                              onChange={(e) => {
                                let _data = editData;
                                _data = {
                                  ...editData,
                                  name: e?.target?.value,
                                };
                                setEditData(_data);
                              }}
                              value={editData.name}
                              placeholder="ຊື່ສິນຄ້າ..."
                              style={{
                                border: editData.name ? "" : "solid 1px red",
                                width: "auto",
                              }}
                            />
                          ) : (
                            <div>{unit?.name}</div>
                          )}
                        </td>
                        <td style={{ paddingTop: "1rem" }}>
                          {" "}
                          {moment(unit?.createdAt).format("DD/MM/YYYY")}
                        </td>

                        {isEdit == true && editIndex === index ? (
                          <td style={{ width: "30%" }}>
                            <div style={{ display: "flex" }}>
                              <CustomButton
                                width="149px"
                                height="42px"
                                color="#3058A6"
                                background="#F1F1F1"
                                borderRadius="8px"
                                title="ຍົກເລີກ"
                                onClick={() => onCancelEditData()}
                              />
                              &ensp;
                              <CustomButton
                                width="149px"
                                height="42px"
                                borderRadius="8px"
                                title={loadingUpdate ? <Spinner /> : "ບັນທືກ"}
                                onClick={() => _updateUnit()}
                              />
                            </div>
                          </td>
                        ) : (
                          <td>
                            <div
                              style={{ display: "flex", alignItems: "center" , gap: 5, justifyContent:'end'}}>
                              <Button variant="outline-primary" onClick={() => onEditData(unit, index)}><ReactIcons.FaEdit /></Button>
                              <Button variant="outline-danger" onClick={() => handleShowDelete(unit?.id, unit?.name)}><ReactIcons.MdDeleteOutline /></Button>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div>
                  {Unit?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີຫົວໝວ່ຍກະລຸນາໄປເພີ່ມຫົວໝວ່ຍກ່ອນ !!!</p>
                    </div>
                  )}
                </div>
              )}

              {/* {unitTotal > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                  }}>
                  {unitTotal && (
                    <div className="show">
                      ກຳລັງສະແດງ {50 * _skip - 49}-
                      {50 * _skip > unitTotal ? unitTotal : 50 * _skip} ຈາກ{" "}
                      {unitTotal}
                    </div>
                  )}
                  <div>{Pagination_helper(unitTotal, "", ``)}</div>
                  <div></div>
                  <div />
                </div>
              ) : (
                ""
              )} */}
            </>
          )}

          {/* end table */}
        </div>
      </div>

      {/* Fuction Confirm Delete */}

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={
          _confirmeDelete
        }
        title="ແຈ້ງເຕືອນ"
        text={
          `ທ່ານຕອ້ງການລົບຂໍ້ມູນ` + ` ${Delete?.name}` + ` ນີ້ເເທ້ບໍ່!`
        }
      />

      {/* <ConfirmDelete
        title={loadingDelete ? <Spinner /> : "ລົບ"}
        open={showDelete}
        // text={Delete?.username}
        paragrap={
          "ທ່ານຕອ້ງການຈະລົບຂໍ້ມູນ" + ` ${Delete?.username} ` + `ນີ້ເເທ້ບໍ່`
        }
        onClose={() => setShowDelete(false)}
        onSubmit={_confirmeDelete}
      /> */}

      {/* create Unit */}

      <Modal show={showAddUnit} onHide={() => setShowAddUnit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ເພີ່ມຫົວໝວ່ຍ</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            name: "",
            shop: shopId,
          }}
          validate={(values) => {
            // const errors = {};
            // if (!values.userId) {
            //     errors.userId = 'ກະລຸນາປ້ອນ Userid... !';
            // }
            // return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            _createUnit(values);
          }}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <Modal.Body style={{ height: "10em" }}>
                <Form.Label>ຊື່ຫົວໝວ່ຍ</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  placeholder="ຊື່ຫົວໝວ່ຍ..."
                />
              </Modal.Body>
              <Modal.Footer>
                <CustomButton
                  title="ຍົກເລີກ"
                  width="100px"
                  background="#A9B3BD"
                  borderRadius="8px"
                  onClick={() => setShowAddUnit(false)}
                />
                &emsp;
                <CustomButton
                  title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                  width="100px"
                  borderRadius="8px"
                  onClick={() => handleSubmit()}
                />
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>
    </React.Fragment>
  );
}

export default UnitList;
